import {hidden, newInput, tryToDate, visible, getDataByCodePostal, getDataBySiren, cssVal} from "@/data/helpers";
import {def} from "@/data/dictionnaire";


export const changementDenomination = {
    title: "Changement de Dénomination",
    texte: "<strong>{{societeGroup.societeDenomination}}</strong>[[ ({{societeGroup.sigle}})]] {{societeGroup.societeFormeJuridique}}, au capital de {{societeGroup.societeCapital}} €, Siège : {{siegeSocialGroup.societeAdresse}}[[, " +
        "{{siegeSocialGroup.societeAdresse2}}]] {{siegeSocialGroup.societeCodePostal}} {{siegeSocialGroup.societeVille}}, RCS : <span style='text-transform: uppercase'>{{societeGroup.societeRcsVille}}</span> N° {{societeGroup.societeRcs}}. <br>" +
        "Aux termes {{acteGroup.auTermeAssembleDecisionActe}} en date du {{acteGroup.dateDu}}, " +
        "la dénomination sociale a été modifiée pour être remplacée, à compter du {{acteGroup.dateEffet}} par : {{changementDenominationGroup.nouvelleDenomination}}[[ Sigle : {{changementDenominationGroup.sigle}}]]. RCS : {{societeGroup.societeRcsVille}}.",
    script: (text, varText, attribute) => {
        let tmpText = "";
        switch (attribute) {
            case "acteGroup.auTermeAssembleDecisionActe":
                if(varText['acteGroup.auTermeAssembleDecisionActe'] === "d'un acte reçu par Me") {
                    tmpText = 'reçu par Me '+ cssVal(varText['acteGroup.nomNotaire']) +" notaire à "+ cssVal(varText['acteGroup.lieuNotaire']);
                } else {
                    tmpText = cssVal(varText['acteGroup.auTermeAssembleDecisionActe']);
                }
                break;
            case "acteGroup.dateDu":
            case "acteGroup.dateEffet":
                tmpText = cssVal(tryToDate(varText[attribute]));
                break;
            default:
                return undefined;
        }
        return tmpText;
    },
    model: {
        societeGroup: [{}],
        siegeSocialGroup: [{}],
    },
    schema: [
        {
            //0
            name: "societeGroup",
            label: "Société",
            type: "group",
            validation: "required",
            value: [{}],
            children: [
                newInput(def.rcs, '_required', {name: 'societeRcs',
                    on: {
                        change: async (val) => {
                            val = val.target.value.replaceAll(' ', '');
                            if (val.length !== 9) {
                                return false;
                            }

                            const data = await getDataBySiren(val);

                            changementDenomination.model.societeGroup[0] = data.values.societe;
                            changementDenomination.model.siegeSocialGroup[0] = data.values.siegeSocial;

                            const dataCP = await getDataByCodePostal(data.values.siegeSocial.societeCodePostal, data.values.siegeSocial.ville);
                            changementDenomination.schema[1].children[3].options = dataCP.options;
                            changementDenomination.model.siegeSocialGroup[0].societeVille = dataCP.ville_slug;
                        }
                    }
                }),
                    newInput(def.lieuImmatriculation, '_required', {name: 'societeRcsVille'}),
                    newInput(def.denomination, '_required', {name: 'societeDenomination'}),
                    newInput(def.sigle),
                    newInput(def.formesSocietes, '_required', {name: 'societeFormeJuridique'}),
                    newInput(def.montantCapital, '_required', {name: 'societeCapital'}),
            ],
        },
        {
            //1
            name: "siegeSocialGroup",
            label: "Siège social",
            type: "group",
            value: [{}],
            children: [
                newInput(def.adresse, '_required', {name: 'societeAdresse'}),
                newInput(def.adresseSuite, '_required', {name: 'societeAdresse2'}),
                newInput(def.codePostal, '_required', {
                    name: 'societeCodePostal',
                    on: {
                        change: async (val) => {
                            val = val.target.value;
                            if (val.length === 5) {
                                const data = await getDataByCodePostal(val);
                                changementDenomination.schema[1].children[3].options = data.options;

                                if (data.ville_slug !== null) {
                                    changementDenomination.model.siegeSocialGroup[0].societeVille = data.ville_slug;
                                    changementDenomination.model.societeGroup[0].societeRcsVille = data.greffe;
                                }
                            }
                        }
                    }
                }),
                newInput(def.ville, '_validUniqueSelect', {name: 'societeVille'}),
            ]
        },
        {
            //2
            name: "acteGroup",
            label: "Acte",
            type: "group",
            value: [{}],
            children: [
                newInput(def.auTermeAssembleDecisionActe, '_required', {
                    on: {
                        input: (val) => {
                            changementDenomination.schema[2].children[1] = val === "6" ? visible(changementDenomination.schema[2].children[1]) : hidden(changementDenomination.schema[2].children[1]);
                            changementDenomination.schema[2].children[2] = val === "6" ? visible(changementDenomination.schema[2].children[2]) : hidden(changementDenomination.schema[2].children[2]);
                        }
                    }
                }),
                newInput(def.nomNotaire, '_required', {}, 'hidden'),
                newInput(def.lieuNotaire, '_required', {}, 'hidden'),
                newInput(def.dateDu, '_required'),
                newInput(def.dateEffet, '_required'),
            ]
        },
        {
            //3
            name: "changementDenominationGroup",
            label: "Changement dénomination",
            value: [{}],
            type: "group",
            children: [
                newInput({name: "nouvelleDenomination", label: "Nouvelle dénomination", type: "text"}, '_required'),
                newInput({name: "sigle", label: "Sigle", type: "text"})
            ]
        }
    ]
};